import { LARGE_ICON_SIZE_STYLES } from "../../../styles";

export const SLIDEOVER_EDIT_ICON_WRAPPER_STYLES =
  "place-self-center mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-stone-100 dark:bg-stone-900";
export const SLIDEOVER_EDIT_ICON_ICON_STYLES = `dark:text-stone-300 text-stone-400  ${LARGE_ICON_SIZE_STYLES}`;
